<kendo-splitbutton [data]="filterViews"
                   [textField]="'name'"
                   (itemClick)="onItemClick($event)"
                   (buttonClick)="onButtonClick()"
                   [ngClass]="'filter-selector-btn'">
  <span id="selectedFilterName" class="filter-selector-text" title="{{selectedFilter?.name}}">{{selectedFilter?.name}}</span>
</kendo-splitbutton>
